<template>
	<div>
		<v-divider></v-divider>

		<v-card-text>
			<v-subheader>
				This section allows you to setup the Meeting Rooms within your company. These can be used when scheduling Performance Reviews.
			</v-subheader>

			<v-data-table disable-initial-sort :headers="headers" :items="meetingLocations" hide-actions class="elevation-1 mt-3">
				<template slot="items" slot-scope="props">
					<tr>
						<td class="text-xs-left">{{ props.item.name }}</td>
						<td class="text-xs-left">{{ getMeetingLocationType(props.item.type) }}</td>
						<td class="justify-center px-0">
							<v-icon small class="mr-2" @click="edit(props.item)">
								edit
							</v-icon>
							<v-icon small @click="deleteItem(props.item)">
								delete
							</v-icon>
						</td>
					</tr>
				</template>
			</v-data-table>
		</v-card-text>
	</div>
</template>

<script>
	import MeetingLocationEditor from '@/components/settings/MeetingLocationEditor';
	import typeFriendlyMixin from '@/mixins/typeFriendlyMixin';

	export default {
		components: {
			MeetingLocationEditor
		},
		props: {
			meetingLocations: {
				required: true,
				type: Array
			}
		},
		data() {
			return {
				headers: [
					{ text: 'Name', value: 'name' },
					{ text: 'Type', value: 'type' },
					{ text: '', value: 'actions', sortable: false }
				]
			};
		},
		methods: {
			edit(item) {
				this.$emit('onEdit', item);
			},
			deleteItem(item) {
				this.$emit('onDelete', item);
			}
		},
		mixins: [typeFriendlyMixin]
	};
</script>

<style></style>
